export default "__VITE_ASSET__uxOk4py5__"